export const DELETE_PROCESS_STATEMENT_REQUEST = 'DELETE_PROCESS_STATEMENT_REQUEST';

export const deleteProcessStatementRequest = ( id ) => ({
    type: DELETE_PROCESS_STATEMENT_REQUEST,
    payload: { id }
});
